<ng-container *ngIf="!isRegistration; else registrationFields">
  <section class="settings-section">
    <h2 class="ewrs-section-title">Profile information</h2>
    <p class="section-description">Used to determine reporting structure and approvals.</p>

    <div class="settings-field-row">
      <app-ods-input
        class="settings-field"
        [labelText]="'Reporting manager *'"
        [labelFor]="'reportingManagerSelect'"
        [labelId]="'reportingManagerLabel'"
      >
        <mat-form-field [class.field-error]="showManagerRequiredError">
          <mat-select
            id="reportingManagerSelect"
            [(value)]="manager"
            aria-labelledby="reportingManagerLabel"
            placeholder="Search"
            required
          >
            <mat-option>
              <ngx-mat-select-search
                [ariaLabel]="'Search for user'"
                [formControl]="userSearchControl"
                [placeholderLabel]="'Search'"
                [clearSearchInput]="false"
                [noEntriesFoundLabel]="noResultsLabel"
              ></ngx-mat-select-search>
            </mat-option>

            <mat-option *ngFor="let user of searchedUsers" [value]="user">
              {{ user.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div *ngIf="showManagerRequiredError" class="field-error-label">Select a reporting manager.</div>
      </app-ods-input>

      <app-ods-input
        class="settings-field"
        [labelText]="'Division *'"
        [labelFor]="'divisionSelect'"
        [labelId]="'divisionLabel'"
      >
        <mat-form-field [class.field-error]="showDivisionRequiredError">
          <mat-select
            id="divisionSelect"
            aria-label="Select your division"
            [(value)]="currentDivision"
            placeholder="Search"
            required
            (selectionChange)="changeDivision($event)"
            (openedChange)="onDivisionOpened($event)"
            [compareWith]="compareDivision"
          >
            <mat-option>
              <ngx-mat-select-search
                [ariaLabel]="'Search for division'"
                [formControl]="divisionSearchControl"
                [placeholderLabel]="'Search'"
                [clearSearchInput]="false"
                [noEntriesFoundLabel]="noResultsLabel"
              ></ngx-mat-select-search>
            </mat-option>

            <mat-option *ngFor="let division of divisions" [value]="division">
              {{ division.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div *ngIf="showDivisionRequiredError" class="field-error-label">Select a division.</div>
      </app-ods-input>
    </div>
  </section>

  <section class="settings-section">
    <h2 class="ewrs-section-title">Delegate assignment</h2>
    <p class="section-description">Delegates can create, modify or cancel reservations on your behalf.</p>

    <app-ods-input
      class="delegate-search-field"
      [labelText]="'Add a delegate'"
      [labelFor]="'delegateSelect'"
      [labelId]="'delegateSelectLabel'"
    >
      <div class="delegate-search-control">
        <mat-form-field>
          <input
            matInput
            id="delegateSelect"
            type="text"
            placeholder="Search"
            aria-labelledby="delegateSelectLabel"
            [formControl]="delegateSearchControl"
            [matAutocomplete]="delegateAuto"
            [disabled]="disableDelegate"
            autocomplete="off"
          />
          <mat-autocomplete
            #delegateAuto="matAutocomplete"
            [displayWith]="displayDelegate"
            (optionSelected)="delegateSelected($event.option.value)"
          >
            <mat-option *ngIf="!searchedDelegates?.length" disabled>
              {{ noResultsLabel }}
            </mat-option>
            <mat-option *ngFor="let user of searchedDelegates" [value]="user" [attr.aria-label]="user.name">
              {{ user.name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <button
          type="button"
          mat-raised-button
          color="primary"
          class="delegate-add-button"
          (click)="addDelegate()"
          [disabled]="disableDelegate"
        >
          Add
        </button>
      </div>
    </app-ods-input>
    <div *ngIf="delegateFeedback" class="delegate-feedback">{{ delegateFeedback }}</div>

    <h3>My delegates (up to 5)</h3>
    <div class="delegate-list" [class.delegate-list-empty]="!delegates?.length">
      <p *ngIf="!delegates?.length">You don’t have any delegates yet. Use the search above to add them.</p>

      <div *ngIf="delegates?.length" class="delegate-pill-list">
        <div *ngFor="let delegate of delegates; let i = index" class="delegate-pill">
          <span>{{ delegate.name }}</span>
          <button
            type="button"
            class="clear-delegate"
            mat-icon-button
            [matTooltip]="'Remove ' + delegate.name"
            aria-label="Remove delegate"
            (click)="removeDelegate(i)"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </section>
  <section class="settings-section notification-section" *ngIf="showNotificationSettings">
    <h2 class="ewrs-section-title">Notification settings</h2>
    <p class="section-description">Choose which notifications you would like to receive.</p>

    <div class="notification-row">
      <div>
        <h3>Notify me when team members make bookings</h3>
        <p>Receive booking confirmation and cancellation emails when direct reports make or cancel reservations.</p>
      </div>
      <mat-slide-toggle
        color="primary"
        [(ngModel)]="managerNotificationsEnabled"
        aria-label="Notify me when team members make bookings"
      ></mat-slide-toggle>
    </div>
  </section>

  <div class="settings-actions">
    <button mat-raised-button color="primary" (click)="save()">Save changes</button>
    <button mat-stroked-button color="primary" (click)="cancel()">Cancel</button>
  </div>
</ng-container>

<ng-template #registrationFields>
  <section class="settings-section">
    <div class="settings-field-row">
      <app-ods-input
        class="settings-field"
        [labelText]="'Reporting manager *'"
        [labelFor]="'reportingManagerSelect'"
        [labelId]="'reportingManagerLabel'"
      >
        <mat-form-field [class.field-error]="showManagerRequiredError">
          <mat-select
            id="reportingManagerSelect"
            [(value)]="manager"
            aria-labelledby="reportingManagerLabel"
            placeholder="Search"
            required
          >
            <mat-option>
              <ngx-mat-select-search
                [ariaLabel]="'Search for user'"
                [formControl]="userSearchControl"
                [placeholderLabel]="'Search'"
                [clearSearchInput]="false"
                [noEntriesFoundLabel]="noResultsLabel"
              ></ngx-mat-select-search>
            </mat-option>

            <mat-option *ngFor="let user of searchedUsers" [value]="user">
              {{ user.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div *ngIf="showManagerRequiredError" class="field-error-label">Select a reporting manager.</div>
      </app-ods-input>

      <app-ods-input
        class="settings-field"
        [labelText]="'Division *'"
        [labelFor]="'divisionSelect'"
        [labelId]="'divisionLabel'"
      >
        <mat-form-field [class.field-error]="showDivisionRequiredError">
          <mat-select
            id="divisionSelect"
            aria-label="Select your division"
            [(value)]="currentDivision"
            placeholder="Search"
            required
            (selectionChange)="changeDivision($event)"
            (openedChange)="onDivisionOpened($event)"
            [compareWith]="compareDivision"
          >
            <mat-option>
              <ngx-mat-select-search
                [ariaLabel]="'Search for division'"
                [formControl]="divisionSearchControl"
                [placeholderLabel]="'Search'"
                [clearSearchInput]="false"
                [noEntriesFoundLabel]="noResultsLabel"
              ></ngx-mat-select-search>
            </mat-option>

            <mat-option *ngFor="let division of divisions" [value]="division">
              {{ division.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div *ngIf="showDivisionRequiredError" class="field-error-label">Select a division.</div>
      </app-ods-input>
    </div>
  </section>

  <section class="settings-section">
    <h2 class="ewrs-section-title">My delegates (up to 5)</h2>

    <app-ods-input
      class="delegate-search-field"
      [labelText]="'Add a delegate'"
      [labelFor]="'delegateSelect'"
      [labelId]="'delegateSelectLabel'"
    >
      <div class="delegate-search-control">
        <mat-form-field>
          <input
            matInput
            id="delegateSelect"
            type="text"
            placeholder="Search"
            aria-labelledby="delegateSelectLabel"
            [formControl]="delegateSearchControl"
            [matAutocomplete]="registrationDelegateAuto"
            [disabled]="disableDelegate"
            autocomplete="off"
          />
          <mat-autocomplete
            #registrationDelegateAuto="matAutocomplete"
            [displayWith]="displayDelegate"
            (optionSelected)="delegateSelected($event.option.value)"
          >
            <mat-option *ngIf="delegateSearchControl.value && !searchedDelegates?.length" disabled>
              {{ noResultsLabel }}
            </mat-option>
            <mat-option *ngFor="let user of searchedDelegates" [value]="user" [attr.aria-label]="user.name">
              {{ user.name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <button
          type="button"
          mat-raised-button
          color="primary"
          class="delegate-add-button"
          (click)="addDelegate()"
          [disabled]="disableDelegate"
        >
          Add
        </button>
      </div>
    </app-ods-input>
    <div *ngIf="delegateFeedback" class="delegate-feedback">{{ delegateFeedback }}</div>

    <div class="delegate-list" [class.delegate-list-empty]="!delegates?.length">
      <p *ngIf="!delegates?.length">No delegates selected.</p>

      <div *ngIf="delegates?.length" class="delegate-pill-list">
        <div *ngFor="let delegate of delegates; let i = index" class="delegate-pill">
          <span>{{ delegate.name }}</span>
          <button
            type="button"
            class="clear-delegate"
            mat-icon-button
            [matTooltip]="'Remove ' + delegate.name"
            aria-label="Remove delegate"
            (click)="removeDelegate(i)"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </section>

  <section class="settings-section">
    <app-ods-checkbox
      class="registration-declaration"
      [checkboxId]="'registrationDeclarationCheckbox'"
      [checked]="isChecked"
      (checkedChange)="declarationChange($event)"
    >
      I hereby acknowledge and agree that I will review and abide by all procedures therein before accessing any
      workspace.
    </app-ods-checkbox>
  </section>

  <div class="settings-actions">
    <button
      mat-raised-button
      class="registration-submit-button"
      (click)="save()"
      [disabled]="isDisabled"
      color="primary"
    >
      Register
    </button>
  </div>
</ng-template>
